import { writable } from "svelte/store";
import { createLocalStorageStore, global_state } from "../../service/store";

export const user_general_instructions = createLocalStorageStore('draft_reasoner_user_general_instructions', "");

export const component_state = writable(null);

global_state.subscribe(s => {
    component_state.set(s.draft);
});



export const questions_1 = {
    "q_1": {
        "title": "1.1 What is the scientific or technological objective/end goal of the project?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_2": {
        "title": "1.2 In terms of the definition of scientific or technological R&D, activities should be systematic investigative or systematic experimental. Explain the proposed scientific or technological R&D activities and how they would meet this requirement.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_3": {
        "title": "1.3 It is a requirement that activities relevant to the scientific or technological R&D project should be aimed at resolving scientific or technological uncertainty. Explain this scientific or technological uncertainty.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_4": {
        "title": "1.4 Describe how the resolution of the scientific or technological uncertainty cannot be deduced by a person skilled in the field on the basis of generally available scientific or technological knowledge or experience.",
        "dependencies": ["q_3"],
        "selected_model": "gpt-4o"
    },
    "q_5": {
        "title": "1.5 Explain the scientific or technological advancement that the project aims to achieve.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_6": {
        "title": "1.6 What is the prior art – what is the closest product/process/knowledge in existence to be improved on or replaced?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_7": {
        "title": "1.7 What are the short comings of such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6"],
        "selected_model": "gpt-4o"
    },
    "q_8": {
        "title": "1.8 How would your proposed solution differ on a scientific or technological level from such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6", "q_7"],
        "selected_model": "gpt-4o"
    },
    "q_9": {
        "title": "2.1 Describe the new scientific or technical knowledge you intend to discover.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
};


export const questions_2 = {
    "q_1": {
        "title": "1.1 What is the scientific or technological objective/end goal of the project?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_2": {
        "title": "1.2 In terms of the definition of scientific or technological R&D, activities should be systematic investigative or systematic experimental. Explain the proposed scientific or technological R&D activities and how they would meet this requirement.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_3": {
        "title": "1.3 It is a requirement that activities relevant to the scientific or technological R&D project should be aimed at resolving scientific or technological uncertainty. Explain this scientific or technological uncertainty.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_4": {
        "title": "1.4 Describe how the resolution of the scientific or technological uncertainty cannot be deduced by a person skilled in the field on the basis of generally available scientific or technological knowledge or experience.",
        "dependencies": ["q_3"],
        "selected_model": "gpt-4o"
    },
    "q_5": {
        "title": "1.5 Explain the scientific or technological advancement that the project aims to achieve.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_6": {
        "title": "1.6 What is the prior art – what is the closest product/process/knowledge in existence to be improved on or replaced?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_7": {
        "title": "1.7 What are the short comings of such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6"],
        "selected_model": "gpt-4o"
    },
    "q_8": {
        "title": "1.8 How would your proposed solution differ on a scientific or technological level from such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6", "q_7"],
        "selected_model": "gpt-4o"
    },
    "q_9": {
        "title": "2.1 Describe the proposed product, process or service that you intend to create or develop.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_10": {
        "title": "2.2 Describe how the product, process or service is new or significantly improved.",
        "dependencies": ["q_9"],
        "selected_model": "gpt-4o"
    },
};




export const questions_3 = {
    "q_1": {
        "title": "1.1 What is the scientific or technological objective/end goal of the project?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_2": {
        "title": "1.2 In terms of the definition of scientific or technological R&D, activities should be systematic investigative or systematic experimental. Explain the proposed scientific or technological R&D activities and how they would meet this requirement.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_3": {
        "title": "1.3 It is a requirement that activities relevant to the scientific or technological R&D project should be aimed at resolving scientific or technological uncertainty. Explain this scientific or technological uncertainty.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_4": {
        "title": "1.4 Describe how the resolution of the scientific or technological uncertainty cannot be deduced by a person skilled in the field on the basis of generally available scientific or technological knowledge or experience.",
        "dependencies": ["q_3"],
        "selected_model": "gpt-4o"
    },
    "q_5": {
        "title": "1.5 Explain the scientific or technological advancement that the project aims to achieve.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_6": {
        "title": "1.6 What is the prior art – what is the closest product/process/knowledge in existence to be improved on or replaced?",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_7": {
        "title": "1.7 What are the short comings of such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6"],
        "selected_model": "gpt-4o"
    },
    "q_8": {
        "title": "1.8 How would your proposed solution differ on a scientific or technological level from such product(s)/process(es)/knowledge?",
        "dependencies": ["q_6", "q_7"],
        "selected_model": "gpt-4o"
    },
    "q_9": {
        "title": "2.1 What R&D activities are you conducting? (Consult the Regulations on the other criteria for multisource pharmaceutical products as they relate to the R&D Tax Incentive).",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_10": {
        "title": "2.2 Identify the existing pharmaceutical product for which a generic is being proposed/ developed.",
        "dependencies": null,
        "selected_model": "gpt-4o"
    },
    "q_11": {
        "title": "2.3 The result of your R&D is likely to create: (i) A pharmaceutically equivalent product (ii) A pharmaceutically alternative product (iii) A therapeutically equivalent product (iv)	An interchangeable pharmaceutical product? Select one and substantiate.",
        "dependencies": ["q_10"],
        "selected_model": "gpt-4o"
    },
};
